import { render, staticRenderFns } from "./EmptyDetail.vue?vue&type=template&id=467bca58&scoped=true&"
import script from "./EmptyDetail.vue?vue&type=script&lang=ts&"
export * from "./EmptyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyDetail.vue?vue&type=style&index=0&id=467bca58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467bca58",
  null
  
)

export default component.exports